// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 21 5\"> <g transform=\"translate(-167 -248)\"> <circle class=circle1 cx=2.5 cy=2.5 r=2.5 transform=\"translate(167 248)\"/> <circle class=circle2 cx=2.5 cy=2.5 r=2.5 transform=\"translate(175 248)\"/> <circle class=circle3 cx=2.5 cy=2.5 r=2.5 transform=\"translate(183 248)\"/> </g> </svg>";
// Exports
module.exports = code;